import { useStoreon } from 'storeon/react'

export interface IConfig {
  add_work: string
  authorization: string
  best_in_profession: string
  championships: string
  championship_application: string
  championship_detail: string
  competition_regulations: string
  contest_detail: string
  detail_game: string
  games: string
  education: string
  forgot_your_password: string
  home_url: string
  institution_detail: string
  leaders_contacts: string
  lecture: string
  lesson: string
  live_like_a_host: string
  manual_chempionat: string
  media_detail: string
  news: string
  news_detail: string
  ok_link: string
  personal_data_policy: string
  privacy_policy: string
  profession_competition: string
  profile: string
  recommend_to_know: string
  quiz: string
  success_story: string
  tournaments: string
  tournaments_detail: string
  urban_club: string
  what_read: string
  vk_link: string
}

interface IMenus {
  cabinet: any[]
  footer: any[]
  header: any[]
  education: any[]
}

interface IGlobal {
  config: IConfig
  menus: IMenus
}

interface IObject {
  date_create: string
  title: string
  id: number | string
  detail: string
}

interface IInitState {
  global: IGlobal
  object: IObject
}

interface IPage {
  page_model: string
  init_state: IInitState
}

const usePage = (): IPage => {
  const { page } = useStoreon('page')
  return page.data.page
}

export default usePage
